export const formatDate = (propsDate, addYears = 0) => {
  if (!propsDate || isNaN(new Date(propsDate).getTime())) {
    return "Invalid Date";
  }

  const date = new Date(propsDate);
  date.setFullYear(date.getFullYear() + addYears); // Add years

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
};
